import * as $ from "jquery";
import * as _ from "lodash";
import { PermissionCollection } from "../../../collections/Permissions";
import { UserGroupCollection } from "../../../collections/UserGroups";
import { BaseEditSubView, BaseEditSubViewOptions } from "./_BaseEditView";
import { EditReportsNavView } from "./EditReportsNavView";

export class EditPermissionsView extends BaseEditSubView {
    private template = _.template(require("../../../templates/reports/editReports/editPermissions.html"));
    private navView: EditReportsNavView;
    private userGroupCollection: UserGroupCollection = null;
    private permissionsCollections: { [key: number]: PermissionCollection } = {};

    constructor(options: BaseEditSubViewOptions) {
        super(
            <any>_.extend(options, {
                events: {
                    "click .save-destination.btn-success": "handleSavePermissions",
                    "change .permission-checkbox": "handlePermissionChange",
                    "change .all__permissions-toggle": "handleAllPermissionsToggleChange",
                },
            })
        );

        this.navView = new EditReportsNavView(options);
    }

    render() {
        this.$el.html(
            this.template({
                permissionCollection: this.options.permissionCollection,
                report: this.options.report,
                orgId: this.options.orgId,
            })
        );

        // Render the nav bar
        this.renderSubViews();

        // Load permissions & render toggle buttons
        this.loadCollections();
        return this;
    }

    renderSubViews() {
        // Render the nav bar
        this.$(".nav-container").empty().append(this.navView.render().el);
    }

    loadCollections() {
        var orgId = this.options.orgId;

        this.permissionsCollections = {};
        this.userGroupCollection = new UserGroupCollection([], { organizationId: Number(orgId) });

        var permissionsCollectionDeferreds = [];
        this.userGroupCollection.on("sync", () => {
            this.userGroupCollection.each((g) => {
                var id = g.get("id");

                this.permissionsCollections[id] = new PermissionCollection([], { userGroupId: id });
                permissionsCollectionDeferreds.push(this.permissionsCollections[id].getCollectionFetchPromise());
            });

            $.when.apply($, permissionsCollectionDeferreds).done(() => {
                this.renderPermissionsToggle();

                // Show all permission toggle
                const table = $('.all__permissions-toggle').parents(".table");
                this.updateAllPermissionsToggleStates(table);
                (<any>$('input[type="checkbox"].all__permissions-toggle')).bootstrapToggle();
                $(".all__permissions-toggle-container").toggleClass("hidden");
            });
        });
        this.userGroupCollection.fetch({ reset: true });

        this.$(".permissions-loading").removeClass("hidden");
        this.$(".permissions-loaded").addClass("hidden");
        this.$(".add-dashboard-btn").prop("disabled", true);
    }

    renderPermissionsToggle() {
        this.$(".permissions-loading").addClass("hidden");
        this.$(".permissions-loaded").removeClass("hidden");

        var reportId = this.options.report.get("id");
        var rows = [];
        this.userGroupCollection.each((group) => {
            var id = group.get("id");
            if (!this.options.permissionCollection.canModifyUserGroupPermissions(id)) return;

            var checkedView = false;
            var checkedModifyDelete = false;
            var disabled = false;

            // Check if this is a new report
            if (group.get("is_admin") || this.userGroupCollection.length === 1) {
                checkedView = true;
                checkedModifyDelete = true;
                disabled = true;
            } else if (reportId) {
                checkedView = this.permissionsCollections[id].canViewReport(reportId);
                checkedModifyDelete =
                    this.permissionsCollections[id].canModifyReport(reportId) &&
                    this.permissionsCollections[id].canDeleteReport(reportId);
            }

            rows.push(
                '<tr data-group-id="' +
                    id +
                    '">' +
                    "<td>" +
                    group.get("name") +
                    "</td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-view" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (checkedView ? " checked" : "") +
                    (disabled ? " disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-modify" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (checkedModifyDelete ? " checked" : "") +
                    (disabled ? " disabled" : "") +
                    "></td>" +
                    "</tr>"
            );
        });

        if (!rows.length) {
            rows.push(
                '<tr class="danger text-danger text-center">' +
                    '<td colspan="4">' +
                    "You may not grant permission to any team in this organization. <br>" +
                    "Since this report would be inaccessible to you, " +
                    "you may not create or modify dashboards for this organization" +
                    "</td>" +
                    "</tr>"
            );
        }

        this.$("tbody.permissions-loaded").html(rows.join(""));
        (<any>this.$('.permissions-loaded input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
    }

    handlePermissionChange(e: JQuery.UIEventBase) {
        var target = $(e.currentTarget);
        var checked = target.is(":checked");

        if (checked) {
            if (target.hasClass("permission-modify")) {
                target.parents("tr").find(".permission-view").prop("checked", true).change();
            }
        } else {
            if (target.hasClass("permission-view")) {
                target.parents("tr").find(".permission-modify").prop("checked", false).change();
            }
        }

        // Identify the parent table
        const table = target.closest(".table");
        if (!table.length) return;

        this.updateAllPermissionsToggleStates(table);
    }

    updateAllPermissionsToggleStates(table: JQuery) {
        // Iterate over all column-level toggles in the current table
        const columns = table.find(`.all__permissions-toggle`);
        columns.each((_, toggle) => {
            const $toggle = $(toggle);
            const permissionType = $toggle.attr("data-permission-type");

            // Find all checkboxes in the current column within the table
            const checkboxes = table.find(`.permission-checkbox.permission-${permissionType}:not(:disabled)`);
            const allChecked = checkboxes.length > 0 && checkboxes.toArray().every((cb) => $(cb).is(":checked"));

            // Temporarily destroy the bootstrap toggle to change its state without triggering the event
            ($toggle as any).bootstrapToggle('destroy');
            $toggle.prop("checked", allChecked);
            ($toggle as any).bootstrapToggle();
        });
    }

    handleAllPermissionsToggleChange(e: Event) {
        const target = $(e.currentTarget);
        const isChecked = target.is(":checked");
        const permissionType = target.attr("data-permission-type");

        // Search for all checkboxes in the table that belong to the same column
        const table = target.closest(".table");
        if (!table.length) return;

        table.find(`.permission-checkbox.permission-${permissionType}:not(:disabled)`).each((_, checkbox) => {
            const $checkbox = $(checkbox);
            // Bypass TypeScript type checking for bootstrapToggle
            ($checkbox as any).bootstrapToggle(isChecked ? "on" : "off");
        });
    }

    getPermissionsForSave() {
        var permissions = {};
        _.map(this.$(".permissions-loaded tr"), (groupRow) => {
            var id = $(groupRow).attr("data-group-id");
            var perms = [];

            if ($(groupRow).find(".permission-view").is(":checked")) perms.push("view");
            if ($(groupRow).find(".permission-modify").is(":checked")) perms.push("modify", "delete");

            if (perms.length) {
                permissions[id] = perms;
            }
        });
        return permissions;
    }

    handleSavePermissions(e: JQuery.UIEventBase) {
        e.preventDefault();

        this.$(".permissions-nav-buttons").addClass("hidden");
        this.$(".permissions-save-spinner").removeClass("hidden");

        var report = this.options.report;

        $.ajax({
            type: "PUT",
            url: this.options.reportsCollection.url() + "/" + this.options.orgId + "/" + report.get("id"),
            data: JSON.stringify({
                permissions: this.getPermissionsForSave(),
                dashboardId: report.get("dashboard_id"),
                format: report.get("format"),
                interval: report.get("interval"),
                name: report.get("name"),
                recipient: report.get("recipient"),
                timezone: report.get("timezone"),
                offset: report.get("offset"),
            }),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            complete: (res) => {
                setTimeout(() => {
                    // Make sure the spinner displays for at least half a second
                    this.refetchCollectionsAndShow(report.get("id"), "permissions");
                    this.$(".permissions-nav-buttons").removeClass("hidden");
                    this.$(".permissions-save-spinner").addClass("hidden");
                }, 500);
            },
        });
    }

    refetchCollectionsAndShow(reportId, view) {
        $.when(this.options.reportsCollection.fetch()).done(() => {
            window.location.hash = "#/reports/" + this.options.orgId + "/" + reportId + "/edit/" + view;

            window['App'].Bus.trigger('navigation:update');
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/editReports/EditPermissionsView.ts